module.exports = new __parcel__URL__("ian_goes_cover.e9be1e80.jpg").toString();